import { useMutation } from '@apollo/client/react';

import {
  GetYakumaruOrganizationSettingOnOrganizationDocument,
  UpdateYakumaruOrganizationSettingOnOrganizationDocument,
} from '~/graphql/generated/graphql';

export const useUpdateYakumaruOrganizationSetting = () => {
  const [update, { loading: updating, error }] = useMutation(
    UpdateYakumaruOrganizationSettingOnOrganizationDocument,
    {
      refetchQueries: [{ query: GetYakumaruOrganizationSettingOnOrganizationDocument }],
      awaitRefetchQueries: true,
    },
  );

  return {
    updating,
    error,
    update,
  };
};
